import AlimLoader from '../ui-elements/AlimLoader';
import SurahTile from './SurahTile';
import { useInView } from 'react-intersection-observer';
import surahDetails from '../../data/structure/structure.json';
import { useEffect, useState } from 'react';
import MediaPlayer from '../ui-elements/media-player/MediaPlayer';
import { currentSurahNum } from '../../stores/sessionStore';

// Lazy-loaded SurahTile component
const LazySurahTile = ({ surah, onClickFunc }) => {
    const { ref, inView } = useInView({
        triggerOnce: true, // Ensures loading happens only once
        threshold: 0.1,    // Adjust threshold based on how early you want it to load
    });

    return (
        <>
            {inView ? (
                <SurahTile surah={surah} onClickFunc={onClickFunc} />
            ) : (
                <div ref={ref} className="col-span-12 md:col-span-6 lg:col-span-4 blue-gr-box p-5 search alim-interactive-tile alim-text-color-style">
                    Loading...
                </div>
            )}
        </>
    );
};

const SurahTileContainer=({currentReciter, reciterCode})=>{
    const [isMediaPlayerVisible,setIsMediaPlayerVisible]=useState(false);
    const [nowPlayingSurah,setNowPlayingSurah]=useState(null);

    const showMediaPlayer=(surahName,surahNum,ayahCount)=>{
        setNowPlayingSurah({
            id:Number(surahNum),
            name:surahName,
            count:ayahCount
        });
        setIsMediaPlayerVisible((prev)=>!prev);
    }

    useEffect(()=>{
        if(!isMediaPlayerVisible)
        {
            currentSurahNum.set(null);

            window.dispatchEvent(new CustomEvent('alimMediaPlayerVisibility', {
                detail: { visible: false }
            }));
        }

        if(isMediaPlayerVisible)
        {
            window.dispatchEvent(new CustomEvent('alimMediaPlayerVisibility', {
                detail: { visible: true }
            }));
        }
    },[isMediaPlayerVisible])

    return(
        <>
            <div className="grid grid-cols-12 gap-4">
                    {
                        surahDetails.map((surah, itemIndex) => (
                            <LazySurahTile key={itemIndex} surah={surah} onClickFunc={()=>{
                                showMediaPlayer(surah.title,surah.index,surah.count)
                            }} />
                        ))
                    }
            </div>
            {
                isMediaPlayerVisible?
                    <MediaPlayer closeFunc={setIsMediaPlayerVisible} nowPlaying={nowPlayingSurah} reciter={currentReciter} reciterCode={reciterCode}/>
                :
                    null
            }
        </>
        
    );
}

export default SurahTileContainer;